<template>
  <v-list dense>
    <v-btn
      class="mr-10"
      absolute
      top
      right
      small
      icon
      :disabled="playDisabled"
      @click="play()"
    >
      <v-icon>mdi-motion-play-outline</v-icon>
    </v-btn>
    <v-list-item>
      <v-list-item-action>
        <v-select
          v-model="selectedPreset"
          :items="animationPresets.filter((p) => p.role === role)"
          item-text="name"
          item-value="preset"
          :label="$t('anim.preset')"
          prepend-icon="mdi-clipboard-play-outline"
          @change="applyPreset"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item>
      <v-list-item-action>
        <v-select
          v-model="optionValue.type"
          :items="types"
          item-text="name"
          item-value="value"
          :label="$t('anim.type')"
          prepend-icon="mdi-movie-filter"
          @change="changeType()"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="optionValue.type == 'move'">
      <v-list-item-action>
        <v-select
          v-model="optionValue.direction"
          :items="directions"
          item-text="name"
          item-value="value"
          :label="$t('anim.direction')"
          prepend-icon="mdi-directions-fork"
          @change="changeDirection()"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item>
      <v-list-item-action>
        <v-select
          v-model="optionValue.easing"
          :items="easings"
          item-text="name"
          item-value="value"
          :label="$t('anim.easing')"
          prepend-icon="mdi-speedometer"
          @change="changeEasing()"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item>
      <v-list-item-action>
        <v-text-field
          v-model="formattedDuration"
          :label="$t('anim.duration')"
          prepend-icon="mdi-timelapse"
          type="number"
          min="0.000"
          max="59.999"
          step="0.250"
          lang="en"
          @change="changeDuration()"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item>
      <v-list-item-action>
        <v-text-field
          v-model="formattedDelay"
          :label="$t('anim.delay')"
          prepend-icon="mdi-timer-sand"
          type="number"
          min="0.000"
          max="59.999"
          step="0.250"
          lang="en"
          @change="changeDelay()"
        />
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    elementCurrent: {
      type: Object,
      default: () => {},
    },
    role: {
      // IN or OUT : animation d'entrée ou de sortie
      type: String,
      default: "IN",
    },
  },
  data() {
    return {
      directions: [
        {
          name: this.$t("anim.directions" + this.role + ".top"),
          value: "top",
        },
        {
          name: this.$t("anim.directions" + this.role + ".left"),
          value: "left",
        },
        {
          name: this.$t("anim.directions" + this.role + ".right"),
          value: "right",
        },
        {
          name: this.$t("anim.directions" + this.role + ".bottom"),
          value: "bottom",
        },
      ],
      easings: [
        {
          name: this.$t("anim.easings.linear"),
          value: "linear",
        },
        {
          name: this.$t("anim.easings.easeIn"),
          value: "easeIn",
        },
        {
          name: this.$t("anim.easings.easeOut"),
          value: "easeOut",
        },
        {
          name: this.$t("anim.easings.easeInOut"),
          value: "easeInOut",
        },
        {
          name: this.$t("anim.easings.elasticEaseIn"),
          value: "elasticEaseIn",
        },
        {
          name: this.$t("anim.easings.elasticEaseOut"),
          value: "elasticEaseOut",
        },
        {
          name: this.$t("anim.easings.elasticEaseInOut"),
          value: "elasticEaseInOut",
        },
        {
          name: this.$t("anim.easings.bounceEaseIn"),
          value: "bounceEaseIn",
        },
        {
          name: this.$t("anim.easings.bounceEaseOut"),
          value: "bounceEaseOut",
        },
        {
          name: this.$t("anim.easings.bounceEaseInOut"),
          value: "bounceEaseInOut",
        },
      ],
      types: [
        {
          name: this.$t("anim.types.move"),
          value: "move",
        },
        {
          name: this.$t("anim.types.opacity"),
          value: "opacity",
        },
        {
          name: this.$t("anim.types.scale"),
          value: "scale",
        },
      ],
      optionValue: {
        type: "",
        direction: "",
        easing: "",
        duration: "1.0",
        delay: "0.0",
      },
      animationPresets: [
        // --- ENTRÉES (IN) ---
        {
          name: "Fondu en entrée",
          role: "IN",
          preset: {
            type: "opacity",
            direction: "",
            easing: "easeInOut",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Apparition depuis la gauche",
          role: "IN",
          preset: {
            type: "move",
            direction: "left",
            easing: "easeOut",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Apparition depuis la droite",
          role: "IN",
          preset: {
            type: "move",
            direction: "right",
            easing: "easeOut",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Apparition depuis le bas",
          role: "IN",
          preset: {
            type: "move",
            direction: "bottom",
            easing: "easeOut",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Zoom avant (entrée)",
          role: "IN",
          preset: {
            type: "scale",
            direction: "",
            easing: "elasticEaseOut",
            duration: "1.25",
            delay: "0.0",
          },
        },
        {
          name: "Bondir (entrée)",
          role: "IN",
          preset: {
            type: "move",
            direction: "bottom",
            easing: "bounceEaseOut",
            duration: "1.0",
            delay: "0.0",
          },
        },

        // --- SORTIES (OUT) ---
        {
          name: "Fondu en sortie",
          role: "OUT",
          preset: {
            type: "opacity",
            direction: "",
            easing: "easeInOut",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Disparition vers la gauche",
          role: "OUT",
          preset: {
            type: "move",
            direction: "left",
            easing: "easeIn",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Disparition vers la droite",
          role: "OUT",
          preset: {
            type: "move",
            direction: "right",
            easing: "easeIn",
            duration: "1.0",
            delay: "0.0",
          },
        },
        {
          name: "Zoom arrière (sortie)",
          role: "OUT",
          preset: {
            type: "scale",
            direction: "",
            easing: "elasticEaseIn",
            duration: "1.25",
            delay: "0.0",
          },
        },
        {
          name: "Bondir (sortie)",
          role: "OUT",
          preset: {
            type: "move",
            direction: "top",
            easing: "bounceEaseIn",
            duration: "1.0",
            delay: "0.0",
          },
        },
      ],
      selectedPreset: null,
    };
  },
  computed: {
    formattedDelay: {
      get() {
        return this.optionValue.delay ? this.formatTime(this.optionValue.delay) : "";
      },
      set(value) {
        this.optionValue.delay = this.parseTime(value);
      },
    },
    formattedDuration: {
      get() {
        return this.optionValue.duration ? this.formatTime(this.optionValue.duration) : "";
      },
      set(value) {
        this.optionValue.duration = this.parseTime(value);
      },
    },
    playDisabled: {
      get() {
        return (
          this.optionValue.type === "" ||
          (this.optionValue.type === "move" && this.optionValue.direction === "") ||
          this.optionValue.easing === "" ||
          parseFloat(this.optionValue.duration) <= 0
        );
      },
    },
  },
  watch: {
    elementCurrent: function (element) {
      this.resetAll();
      this.selectedPreset = null;
      if (element) {
        if (this.role == "IN") {
          this.optionValue.type = element.animMvt;
          this.optionValue.direction = element.animValue;
          this.optionValue.easing = element.animEasing;
          this.optionValue.duration = element.animSpeed;
          this.optionValue.delay = element.animDelay;
        } else if (this.role == "OUT") {
          this.optionValue.type = element.animOutMvt;
          this.optionValue.direction = element.animOutValue;
          this.optionValue.easing = element.animOutEasing;
          this.optionValue.duration = element.animOutSpeed;
          this.optionValue.delay = element.animOutDelay;
        }
      }
    },
  },
  created() {
    //
  },
  methods: {
    changeType() {
      if (this.elementCurrent) {
        const type = this.optionValue.type;
        this.elementCurrent.setAnimMvt(type, this.role);
      }
    },
    changeDirection() {
      if (this.elementCurrent) {
        const direction = this.optionValue.direction;
        this.elementCurrent.setAnimValue(direction, this.role);
      }
    },
    changeEasing() {
      if (this.elementCurrent) {
        const easing = this.optionValue.easing;
        this.elementCurrent.setAnimEasing(easing, this.role);
      }
    },
    changeDuration() {
      if (this.elementCurrent) {
        const duration = this.optionValue.duration;
        this.elementCurrent.setAnimSpeed(duration, this.role);
      }
    },
    changeDelay() {
      if (this.elementCurrent) {
        const delay = this.optionValue.delay;
        this.elementCurrent.setAnimDelay(delay, this.role);
      }
    },
    play() {
      if (this.elementCurrent) {
        if (this.role == "IN") {
          this.elementCurrent.createAnimation();
          if (this.elementCurrent.animObj) {
            this.elementCurrent.animObj.play();
          }
        } else {
          this.elementCurrent.createAnimationOut();
          if (this.elementCurrent.animOutObj) {
            this.elementCurrent.animOutObj.play();
            setTimeout(() => {
              this.elementCurrent.reset();
            }, (parseFloat(this.elementCurrent.animOutSpeed) + 1) * 1000);
          }
        }
      }
    },
    formatTime(time) {
      // Implement logic to format time as ##.###
      let parts = time.replace(",", ".");
      parts = time.split(".");

      let seconds = 0;
      let milliseconds = 0;

      if (parseInt(parts[0], 10)) {
        seconds = parseInt(parts[0], 10);
      }

      if (parseInt(parts[1], 10)) {
        milliseconds = parseInt(parts[1], 10);
        return seconds.toString() + "." + milliseconds.toString();
      }

      return seconds.toString();
    },
    parseTime(formattedTime) {
      let parts = formattedTime.replace(",", ".");
      parts = formattedTime.split(".");
      let seconds = 0;
      let milliseconds = 0;

      if (parseInt(parts[0], 10)) {
        seconds = parseInt(parts[0], 10);
      }

      if (parseInt(parts[1], 10)) {
        milliseconds = parseInt(parts[1], 10);
      }

      if (seconds < 0) {
        seconds = 0;
      }

      if (seconds > 59) {
        seconds = 59;
      }
      if (milliseconds < 0) {
        milliseconds = 0;
      }
      if (milliseconds > 999) {
        milliseconds = 999;
      }

      return seconds.toString() + "." + milliseconds.toString();
    },
    resetAll() {
      this.optionValue = {
        type: "",
        direction: "",
        easing: "",
        duration: "1.0",
        delay: "0.0",
      };
    },
    applyPreset(preset) {
      if (!preset) return;

      // Mise à jour des champs un par un (préserve la réactivité)
      this.optionValue.type = preset.type;
      this.optionValue.direction = preset.direction;
      this.optionValue.easing = preset.easing;
      this.optionValue.duration = preset.duration;
      this.optionValue.delay = preset.delay;

      // Mettre à jour elementCurrent si défini
      if (this.elementCurrent) {
        this.elementCurrent.setAnimMvt(preset.type, this.role);
        this.elementCurrent.setAnimValue(preset.direction, this.role);
        this.elementCurrent.setAnimEasing(preset.easing, this.role);
        this.elementCurrent.setAnimSpeed(preset.duration, this.role);
        this.elementCurrent.setAnimDelay(preset.delay, this.role);
      }
    },
  },
};
</script>
